<template>
  <div class="l-content-inner">
    <div class="c-head">
      <h1 class="head-title">주문서 작성</h1>
      <BreadCrumb :breadcrumbs="initData.page.breadcrumbItems" />
    </div>

    <div class="l-content">
      <!-- D: 주문서 작성 페이지 -->
      <div class="p-order-write-wrap">
        <div class="l-white-box">
          <section class="order-write-box">
            <div class="title-box c-title-level3">
              <strong>주문자 정보</strong>
            </div>
            <!-- D: PC 전용 -->
            <div class="c-table-horizontal only-pc">
              <table>
                <caption>
                  주문자 정보 테이블
                </caption>
                <colgroup>
                  <col style="width: 200px" />
                  <col />
                  <col style="width: 200px" />
                  <col />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">주문자</th>
                    <td>
                      {{ initData.page.userLoginInfo.zbpName }} /
                      {{ initData.page.userLoginInfo.name }} ({{
                        initData.page.userLoginInfo.telf2
                      }})
                    </td>
                    <th scope="row">담당지점/영업사원</th>
                    <td>
                      <div
                        class="c-select type-medium"
                        :class="{
                          'is-onething':
                            initData.page.userLoginInfo?.empList?.length === 1,
                        }"
                      >
                        <select
                          v-model="data.selectedBranch"
                          :disabled="
                            initData.page.userLoginInfo?.empList?.length === 1
                          "
                          @change="saleEmpSelect()"
                        >
                          <option
                            v-for="(item, index) in initData.page.userLoginInfo
                              .empList"
                            :key="index"
                            :value="item"
                          >
                            {{ item.zdeptName }} / {{ item.zempName }} ({{
                              item.zphoneNo
                            }})
                          </option>
                        </select>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- // D: PC 전용 -->
            <!-- D: MO 전용 -->
            <div class="c-table-box only-mo">
              <div class="table-head">
                <div class="col">
                  <strong class="subject">주문자</strong>
                </div>
              </div>
              <div class="table-body col1">
                <div class="grid">
                  <p>
                    {{ initData.page.userLoginInfo.zbpName }} /
                    {{ initData.page.userLoginInfo.name }} ({{
                      initData.page.userLoginInfo.telf2
                    }})
                  </p>
                </div>
              </div>
              <div class="table-head">
                <div class="col">
                  <strong class="subject">담당지점/영업사원</strong>
                </div>
              </div>
              <div class="table-body col1">
                <div class="grid">
                  <div class="c-select type-medium">
                    <template
                      v-if="initData.page.userLoginInfo?.empList?.length > 0"
                    >
                      <select
                        v-model="data.selectedBranch"
                        @change="saleEmpSelect()"
                      >
                        <option
                          v-for="(item, index) in initData.page.userLoginInfo
                            .empList"
                          :key="index"
                          :value="item"
                        >
                          {{ item.zdeptName }} / {{ item.zempName }} ({{
                            item.zphoneNo
                          }})
                        </option>
                      </select>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <!-- // D: MO 전용 -->
          </section>
          <section class="order-write-box">
            <div class="title-box c-title-level3">
              <strong>배송 정보</strong>
            </div>
            <!-- D: PC 전용 -->
            <div class="c-table-horizontal only-pc">
              <table>
                <caption>
                  배송 정보 테이블
                </caption>
                <colgroup>
                  <col style="width: 200px" />
                  <col />
                  <col style="width: 200px" />
                  <col />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">
                      배송방법
                      <button
                        type="button"
                        class="btn-popover"
                        data-popover-trigger="pcDelivery"
                      >
                        <i class="c-icon icon-popover size-small"></i>
                      </button>
                      <div class="c-popover-detail" data-popover="pcDelivery">
                        <div class="text">
                          - 일반: 고객 사업자 주소지 배송 <br />
                          - 조기: 고객 사업자 주소지 배송 <br />
                          - 직송: 요청한 주소지 배송 <br />
                          - 화물: 화물로 발송 요청<br />
                          - 택배: 택배로 발송 요청<br />
                          - 직출: 고객 직접 방문
                        </div>
                      </div>
                    </th>
                    <td colspan="3">
                      <div class="c-round-button-box">
                        <template
                          v-for="(item, index) in initData.codes.dlvCmmCdList"
                          :key="index"
                        >
                          <div
                            class="c-radio-round"
                            v-if="
                              item.cdVl == 25 && includeThinner ? false : true
                            "
                          >
                            <input
                              type="radio"
                              :id="'delivery-raido' + index"
                              name="delivery-option"
                              :value="item.cdVl"
                              v-model="data.selectedDlvCd"
                              @change="selectedDlvCdChange()"
                            />
                            <label :for="'delivery-raido' + index">{{
                              item.cdNm
                            }}</label>
                          </div>
                        </template>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      data.selectedDlvCd == 10 ||
                      data.selectedDlvCd == 15 ||
                      data.selectedDlvCd == 18 ||
                      data.selectedDlvCd == 25
                    "
                  >
                    <th scope="row">배송지 선택</th>
                    <td colspan="3">
                      <div class="location-select-box">
                        <div class="c-round-button-box">
                          <div
                            class="c-radio-round"
                            v-if="
                              data.selectedDlvCd == 25 ||
                              data.selectedDlvCd == 18
                            "
                          >
                            <input
                              type="radio"
                              id="address-radio00"
                              name="address-option"
                              value=""
                              v-model="data.dlvdesSn"
                            />
                            <label for="address-radio00"> 직접입력 </label>
                          </div>

                          <template
                            v-for="(item, index) in initData.list
                              .dlvAddressList"
                            :key="index"
                          >
                            <div class="c-radio-round" v-if="hideDlvdes(item)">
                              <input
                                type="radio"
                                :id="'address-radio' + index"
                                name="address-option"
                                :value="item.dlvdesSn"
                                v-model="data.dlvdesSn"
                              />
                              <label :for="'address-radio' + index">
                                <template
                                  v-if="
                                    item.dlvdesNm != null && item.dlvdesNm != ''
                                  "
                                >
                                  {{ item.dlvdesNm }}
                                </template>
                                <template v-else>
                                  {{ item.acptrNm }}
                                </template>
                              </label>
                            </div>
                          </template>
                        </div>
                        <button
                          v-if="
                            (data.selectedDlvCd == 25 ||
                              data.selectedDlvCd == 18) &&
                            data.selectedAddress?.bscDlvdesYn != 'Y' &&
                            data.selectedAddress?.dlvdesSn != ''
                          "
                          type="button"
                          class="c-util-button type-line-black type-small"
                          @click="showEditPopForEdit"
                          style="margin-right: -35px"
                        >
                          배송지수정
                        </button>
                        <button
                          v-if="
                            data.selectedDlvCd == 25 || data.selectedDlvCd == 18
                          "
                          type="button"
                          class="c-util-button type-line-black type-small"
                          @click="showEditPopForAdd"
                        >
                          배송지추가
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="data.selectedDlvCd == 20">
                    <th scope="row">지역 / 지점</th>
                    <td colspan="3">
                      <div class="flex-box">
                        <div class="c-select type-medium">
                          <select v-model="data.selectedDlvRgn">
                            <option :value="null">지역선택</option>
                            <option
                              v-for="(item, index) in initData.codes.dlvRgnList"
                              :key="index"
                              :value="item.cdVl"
                            >
                              {{ item.cdNm }}
                            </option>
                          </select>
                        </div>
                        <div class="c-select type-medium">
                          <select v-model="data.selectedDlvPnt">
                            <option :value="null">지점선택</option>
                            <option
                              v-for="(item, index) in initData.codes.dlvPntList"
                              :key="index"
                              :value="item.branchNm"
                            >
                              {{ item.branchNm }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="data.selectedDlvCd == 30">
                    <th scope="row">출고지</th>
                    <td colspan="3">
                      {{ initData.codes.userWerksList[0]?.cdNm }}
                    </td>
                  </tr>
                  <tr
                    v-if="
                      data.selectedDlvCd == 10 ||
                      data.selectedDlvCd == 15 ||
                      data.selectedDlvCd == 18 ||
                      data.selectedDlvCd == 20 ||
                      data.selectedDlvCd == 30 ||
                      data.selectedDlvCd == 25
                    "
                  >
                    <th scope="row">
                      <div class="label">
                        <span class="c-required">
                          <span class="sr-only">필수</span>
                        </span>
                        받는 분<br />(최대 10자)
                      </div>
                    </th>
                    <td colspan="3">
                      <div class="c-form-field">
                        <label class="c-input-group">
                          <input
                            type="text"
                            maxlength="10"
                            value="받는 분"
                            title="받는 분"
                            v-model="data.selectedAddress.acptrNm"
                          />
                        </label>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      data.selectedDlvCd == 10 ||
                      data.selectedDlvCd == 15 ||
                      data.selectedDlvCd == 18 ||
                      data.selectedDlvCd == 25
                    "
                  >
                    <th scope="row" class="vct">
                      <div class="label">유선전화</div>
                    </th>
                    <td colspan="3">
                      <div class="c-form-field type-phone">
                        <div class="c-select">
                          <select v-model="data.acptrWrdTelno1">
                            <option value="">선택</option>
                            <option
                              v-for="number in wiredExcNumbers"
                              :key="number"
                              :value="number"
                            >
                              {{ number }}
                            </option>
                          </select>
                        </div>
                        <span class="hyphen">-</span>
                        <label class="c-input-group">
                          <input
                            type="text"
                            title="유선전화 중간 번호"
                            maxlength="4"
                            oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                            v-model="data.acptrWrdTelno2"
                          />
                        </label>
                        <span class="hyphen">-</span>
                        <label class="c-input-group">
                          <input
                            type="text"
                            title="유선전화 뒷 번호"
                            maxlength="4"
                            oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                            v-model="data.acptrWrdTelno3"
                          />
                        </label>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="data.selectedDlvCd != 30">
                    <th scope="row" class="vct">
                      <div class="label">
                        <span class="c-required">
                          <span class="sr-only">필수</span>
                        </span>
                        휴대폰 번호
                      </div>
                    </th>
                    <td colspan="3">
                      <div class="c-form-field type-phone">
                        <div class="c-select">
                          <select v-model="data.acptrMblTelno1">
                            <option value="">선택</option>
                            <option
                              v-for="number in mobileExcNumbers"
                              :key="number"
                              :value="number"
                            >
                              {{ number }}
                            </option>
                          </select>
                        </div>
                        <span class="hyphen">-</span>
                        <!-- 휴대폰 번호 입력창 병합 2025.11.25 -->
                        <label class="c-input-group">
                          <input
                            type="text"
                            title="휴대폰 중간 번호,끝번호 입력"
                            maxlength="8"
                            oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                            v-model="data.acptrMblTelnoRest"
                            @input="onMobileRestInput1"
                          />
                        </label>

                        <!-- <label class="c-input-group">
                          <input
                            type="text"
                            title="휴대폰 중간 번호"
                            maxlength="4"
                            oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                            v-model="data.acptrMblTelno2"
                          />
                        </label>
                        <span class="hyphen">-</span>
                        <label class="c-input-group">
                          <input
                            type="text"
                            title="휴대폰 뒷 번호"
                            maxlength="4"
                            oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                            v-model="data.acptrMblTelno3"
                          />
                        </label> -->
                        <button
                          type="button"
                          class="c-button type-line-black type-small type-icon"
                          :disabled="extTelnosLength > 1"
                          @click="addExtMblTelNo()"
                        >
                          <i class="c-icon icon-plus-black"></i>
                          <span class="sr-only">필드 추가</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="data.selectedDlvCd != 30 && extTelnosLength > 1">
                    <th scope="row">휴대폰 번호 (추가)</th>
                    <td colspan="3">
                      <!-- D: 유효성 검사 실패시 is-danger 클래스 추가 -->
                      <div class="c-form-field type-phone">
                        <div class="c-select">
                          <select v-model="data.acptrMblTelnoSub1">
                            <option value="">선택</option>
                            <option
                              v-for="number in mobileExcNumbers"
                              :key="number"
                              :value="number"
                            >
                              {{ number }}
                            </option>
                          </select>
                        </div>
                        <span class="hyphen">-</span>
                        <!-- 휴대폰 번호 입력창 병합 2025.11.25 -->
                        <label class="c-input-group">
                          <input
                            type="text"
                            title="휴대폰 중간 번호,끝번호 입력"
                            maxlength="8"
                            oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                            v-model="data.acptrMblTelnoSubRest"
                            @input="onMobileRestInput2"
                          />
                        </label>

                        <!-- <label class="c-input-group">
                          <input
                            type="text"
                            title="휴대폰 중간 번호"
                            maxlength="4"
                            oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                            v-model="data.acptrMblTelnoSub2"
                          />
                        </label>
                        <span class="hyphen">-</span>
                        <label class="c-input-group">
                          <input
                            type="text"
                            title="휴대폰 뒷 번호"
                            maxlength="4"
                            oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                            v-model="data.acptrMblTelnoSub3"
                          />
                        </label> -->
                        <button
                          type="button"
                          class="c-button type-line-black type-small type-icon"
                          @click="removeExtMblTelNo()"
                        >
                          <i class="c-icon icon-medium-x2"></i>
                          <span class="sr-only">필드 삭제</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      data.selectedDlvCd == 10 ||
                      data.selectedDlvCd == 15 ||
                      data.selectedDlvCd == 18 ||
                      data.selectedDlvCd == 25
                    "
                  >
                    <th scope="row" class="vct">
                      <div class="label">
                        <span class="c-required">
                          <span class="sr-only">필수</span>
                        </span>
                        주소
                      </div>
                    </th>
                    <td colspan="3">
                      <div class="c-form-field">
                        <label class="c-input-group">
                          <input
                            type="text"
                            maxlength="10"
                            title="우편번호"
                            v-model="data.selectedAddress.zip"
                            readonly
                          />
                        </label>
                        <button
                          type="button"
                          class="c-button type-line-black type-small"
                          @click="openKakaoPostcode"
                          :disabled="
                            data.selectedAddress.bscDlvdesYn == 'Y' &&
                            data.selectedDlvCd != '25' &&
                            data.selectedDlvCd != '18'
                          "
                        >
                          <span class="fw-nr">우편번호 찾기</span>
                        </button>
                      </div>
                      <div class="c-form-field">
                        <label class="c-input-group">
                          <input
                            type="text"
                            title="주소"
                            v-model="data.selectedAddress.roadNmBscAddr"
                            readonly
                          />
                        </label>
                      </div>
                      <div class="c-form-field">
                        <label class="c-input-group">
                          <input
                            type="text"
                            title="상세 주소"
                            v-model="data.selectedAddress.roadNmDtlAddr"
                            @input="addressDtlInput"
                            :readonly="
                              data.selectedAddress.bscDlvdesYn == 'Y' &&
                              data.selectedDlvCd != '25' &&
                              data.selectedDlvCd != '18'
                            "
                          />
                        </label>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">배송요청사항</th>
                    <td colspan="3">
                      <div class="c-form-field">
                        <label class="c-input-group">
                          <input
                            type="text"
                            title="요청사항을 적어주세요."
                            placeholder="요청사항을 적어주세요. (최대 50자 이내)"
                            maxlength="50"
                            v-model="data.dlvDmndCn"
                          />
                        </label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- // D: PC 전용 -->
            <!-- D: MO 전용 -->
            <div class="c-table-box only-mo">
              <div class="table-head">
                <div class="col">
                  <strong class="subject">배송방법</strong>
                  <button
                    type="button"
                    class="btn-popover"
                    data-popover-trigger="moDelivery"
                  >
                    <i class="c-icon icon-popover size-small"></i>
                  </button>
                  <div class="c-popover-detail" data-popover="moDelivery">
                    <div class="text">
                      - 일반: 고객 사업자 주소지 배송 <br />
                      - 조기: 고객 사업자 주소지 배송 <br />
                      - 화물: 화물로 발송 요청<br />
                      - 택배: 택배로 발송 요청<br />
                      - 직출: 고객 직접 방문
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-body col1">
                <div class="grid">
                  <div class="c-round-button-box">
                    <template
                      v-for="(item, index) in initData.codes.dlvCmmCdList"
                      :key="index"
                    >
                      <div
                        class="c-radio-round"
                        v-if="
                          (item.cdVl == 25 || item.cdVl == 18) && includeThinner
                            ? false
                            : true
                        "
                      >
                        <input
                          type="radio"
                          :id="'mo-delivery-raido' + index"
                          name="mo-delivery-option"
                          :value="item.cdVl"
                          v-model="data.selectedDlvCd"
                          @change="selectedDlvCdChange()"
                        />
                        <label :for="'mo-delivery-raido' + index">{{
                          item.cdNm
                        }}</label>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <template v-if="data.selectedDlvCd == 20">
                <div class="table-head">
                  <div class="col">
                    <strong class="subject">지역 / 지점</strong>
                  </div>
                </div>
                <div class="table-body col1">
                  <div class="grid">
                    <div class="flex-box">
                      <div class="c-select type-medium">
                        <select v-model="data.selectedDlvRgn">
                          <option :value="null">지역선택</option>
                          <option
                            v-for="(item, index) in initData.codes.dlvRgnList"
                            :key="index"
                            :value="item.cdVl"
                          >
                            {{ item.cdNm }}
                          </option>
                        </select>
                      </div>
                      <div class="c-select type-medium">
                        <select v-model="data.selectedDlvPnt">
                          <option :value="null">지점선택</option>
                          <option
                            v-for="(item, index) in initData.codes.dlvPntList"
                            :key="index"
                            :value="item.branchNm"
                          >
                            {{ item.branchNm }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <template
                v-if="
                  data.selectedDlvCd == 10 ||
                  data.selectedDlvCd == 15 ||
                  data.selectedDlvCd == 18 ||
                  data.selectedDlvCd == 25
                "
              >
                <div class="table-head">
                  <div class="col">
                    <strong class="subject">배송지 선택</strong>
                  </div>
                </div>
                <div class="table-body col1">
                  <div class="grid">
                    <div class="location-select-box">
                      <div class="c-round-button-box">
                        <div
                          class="c-radio-round"
                          v-if="
                            data.selectedDlvCd == 25 || data.selectedDlvCd == 18
                          "
                        >
                          <input
                            type="radio"
                            id="mo-address-radio00"
                            name="mo-address-option"
                            value=""
                            v-model="data.dlvdesSn"
                          />
                          <label for="mo-address-radio00"> 직접입력 </label>
                        </div>
                        <template
                          v-for="(item, index) in initData.list.dlvAddressList"
                          :key="index"
                        >
                          <div class="c-radio-round" v-if="hideDlvdes(item)">
                            <input
                              type="radio"
                              :id="'mo-address-radio' + index"
                              name="mo-address-option"
                              :value="item.dlvdesSn"
                              v-model="data.dlvdesSn"
                            />
                            <label :for="'mo-address-radio' + index">
                              <template
                                v-if="
                                  item.dlvdesNm != null && item.dlvdesNm != ''
                                "
                              >
                                {{ item.dlvdesNm }}
                              </template>
                              <template v-else>
                                {{ item.acptrNm }}
                              </template>
                            </label>
                          </div></template
                        >
                      </div>
                      <div
                        class="c-btn-area"
                        v-if="
                          data.selectedDlvCd == 25 || data.selectedDlvCd == 18
                        "
                      >
                        <button
                          type="button"
                          class="c-util-button type-line-black"
                          @click="showEditPopForAdd"
                        >
                          추가
                        </button>
                      </div>
                      <div
                        class="c-btn-area"
                        v-if="
                          (data.selectedDlvCd == 25 ||
                            data.selectedDlvCd == 18) &&
                          data.selectedAddress?.bscDlvdesYn != 'Y' &&
                          data.selectedAddress?.dlvdesSn != ''
                        "
                      >
                        <button
                          type="button"
                          class="c-util-button type-line-black"
                          @click="showEditPopForEdit"
                        >
                          수정
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template
                v-if="
                  data.selectedDlvCd == 10 ||
                  data.selectedDlvCd == 15 ||
                  data.selectedDlvCd == 18 ||
                  data.selectedDlvCd == 20 ||
                  data.selectedDlvCd == 30 ||
                  data.selectedDlvCd == 25
                "
              >
                <div class="table-head">
                  <div class="col">
                    <strong class="subject">
                      <span class="c-required">
                        <span class="sr-only">필수</span>
                      </span>
                      받는 분 (최대 10자)</strong
                    >
                  </div>
                </div>
                <div class="table-body col1">
                  <div class="grid">
                    <div class="c-form-field">
                      <label class="c-input-group">
                        <input
                          type="text"
                          title="받는 분"
                          placeholder="받는 분"
                          maxlength="10"
                          v-model="data.selectedAddress.acptrNm"
                        />
                      </label>
                    </div>
                  </div>
                </div>

                <template
                  v-if="
                    data.selectedDlvCd == 10 ||
                    data.selectedDlvCd == 15 ||
                    data.selectedDlvCd == 18 ||
                    data.selectedDlvCd == 25
                  "
                >
                  <div class="table-head">
                    <div class="col">
                      <strong class="subject"> 유선전화 </strong>
                    </div>
                  </div>
                  <div class="table-body col1">
                    <div class="grid">
                      <div class="c-form-field type-phone">
                        <div class="c-select">
                          <select v-model="data.acptrWrdTelno1">
                            <option value="">선택</option>
                            <option
                              v-for="number in wiredExcNumbers"
                              :key="number"
                              :value="number"
                            >
                              {{ number }}
                            </option>
                          </select>
                        </div>
                        <span class="hyphen">-</span>
                        <label class="c-input-group">
                          <input
                            type="text"
                            title="유선전화 중간 번호"
                            maxlength="4"
                            oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                            v-model="data.acptrWrdTelno2"
                          />
                        </label>
                        <span class="hyphen">-</span>
                        <label class="c-input-group">
                          <input
                            type="text"
                            title="유선전화 뒷 번호"
                            maxlength="4"
                            oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                            v-model="data.acptrWrdTelno3"
                          />
                        </label>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-if="data.selectedDlvCd != 30">
                  <div class="table-head">
                    <div class="col">
                      <strong class="subject">
                        <span class="c-required">
                          <span class="sr-only">필수</span>
                        </span>
                        휴대폰 번호</strong
                      >
                    </div>
                  </div>
                  <div class="table-body col1">
                    <div class="grid">
                      <!-- D: 유효성 검사 실패시 is-danger 클래스 추가 -->
                      <div class="c-form-field type-phone">
                        <div class="c-select">
                          <select v-model="data.acptrMblTelno1">
                            <option value="">선택</option>
                            <option
                              v-for="number in mobileExcNumbers"
                              :key="number"
                              :value="number"
                            >
                              {{ number }}
                            </option>
                          </select>
                        </div>
                        <span class="hyphen">-</span>
                        <!-- 휴대폰 번호 입력창 병합 2025.11.25 -->
                        <label class="c-input-group">
                          <input
                            type="text"
                            title="휴대폰 중간 번호,끝번호 입력"
                            maxlength="8"
                            oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                            v-model="data.acptrMblTelnoRest"
                            @input="onMobileRestInput1"
                          />
                        </label>
                        <!-- <label class="c-input-group">
                          <input
                            type="text"
                            title="휴대폰 중간 번호"
                            maxlength="4"
                            oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                            v-model="data.acptrMblTelno2"
                          />
                        </label>
                        <span class="hyphen">-</span>
                        <label class="c-input-group">
                          <input
                            type="text"
                            title="휴대폰 뒷 번호"
                            maxlength="4"
                            oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                            v-model="data.acptrMblTelno3"
                          />
                        </label> -->
                        <button
                          type="button"
                          class="c-button type-line-black type-small type-icon"
                          :disabled="extTelnosLength > 1"
                          @click="addExtMblTelNo()"
                        >
                          <i class="c-icon icon-plus-black"></i>
                          <span class="sr-only">필드 추가</span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <template
                    v-if="data.selectedDlvCd != 30 && extTelnosLength > 1"
                  >
                    <div class="table-head">
                      <div class="col">
                        <strong class="subject">휴대폰번호(추가)</strong>
                      </div>
                    </div>
                    <div class="table-body col1">
                      <div class="grid">
                        <div class="c-form-field type-phone">
                          <div class="c-select">
                            <select v-model="data.acptrMblTelnoSub1">
                              <option value="">선택</option>
                              <option
                                v-for="number in mobileExcNumbers"
                                :key="number"
                                :value="number"
                              >
                                {{ number }}
                              </option>
                            </select>
                          </div>
                          <span class="hyphen">-</span>
                          <!-- 휴대폰 번호 입력창 병합 2025.11.25 -->
                          <label class="c-input-group">
                            <input
                              type="text"
                              title="휴대폰 중간 번호,끝번호 입력"
                              maxlength="8"
                              oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                              v-model="data.acptrMblTelnoSubRest"
                              @input="onMobileRestInput2"
                            />
                          </label>
                          <!-- <label class="c-input-group">
                            <input
                              type="text"
                              title="휴대폰 중간 번호"
                              maxlength="4"
                              oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                              v-model="data.acptrMblTelnoSub2"
                            />
                          </label>
                          <span class="hyphen">-</span>
                          <label class="c-input-group">
                            <input
                              type="text"
                              title="휴대폰 뒷 번호"
                              maxlength="4"
                              oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                              v-model="data.acptrMblTelnoSub3"
                            />
                          </label> -->
                          <button
                            type="button"
                            class="c-button type-line-black type-small type-icon"
                            @click="removeExtMblTelNo()"
                          >
                            <i class="c-icon icon-medium-x2"></i>
                            <span class="sr-only">필드 삭제</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>

                <div class="table-head">
                  <div class="col">
                    <strong class="subject">
                      <span class="c-required">
                        <span class="sr-only">필수</span>
                      </span>
                      주소</strong
                    >
                  </div>
                </div>
                <div class="table-body col1">
                  <div class="grid">
                    <div class="c-form-field">
                      <label class="c-input-group">
                        <input
                          type="text"
                          title="우편번호"
                          readonly
                          v-model="data.selectedAddress.zip"
                        />
                      </label>
                      <button
                        type="button"
                        class="c-button type-line-black type-small"
                        @click="openKakaoPostcode"
                        :disabled="
                          data.selectedAddress.bscDlvdesYn == 'Y' &&
                          data.selectedDlvCd != '25' &&
                          data.selectedDlvCd != '18'
                        "
                      >
                        <span class="fw-nr">우편번호 찾기</span>
                      </button>
                    </div>
                    <div class="c-form-field">
                      <label class="c-input-group">
                        <input
                          type="text"
                          title="주소"
                          v-model="data.selectedAddress.roadNmBscAddr"
                          readonly
                        />
                      </label>
                    </div>
                    <div class="c-form-field">
                      <label class="c-input-group">
                        <input
                          type="text"
                          title="상세 주소"
                          v-model="data.selectedAddress.roadNmDtlAddr"
                          :readonly="
                            data.selectedAddress.bscDlvdesYn == 'Y' &&
                            data.selectedDlvCd != '25' &&
                            data.selectedDlvCd != '18'
                          "
                        />
                      </label>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="data.selectedDlvCd == 30">
                <div class="table-head">
                  <div class="col">
                    <strong class="subject">출고지</strong>
                  </div>
                </div>
                <div class="table-body col1">
                  <div class="grid">
                    <p>{{ initData.codes.userWerksList[0]?.cdNm }}</p>
                  </div>
                </div>
              </template>
              <div class="table-head">
                <div class="col">
                  <strong class="subject">배송요청사항</strong>
                </div>
              </div>
              <div class="table-body col1">
                <div class="grid">
                  <div class="c-form-field">
                    <label class="c-input-group">
                      <input
                        type="text"
                        title="요청사항을 적어주세요."
                        placeholder="요청사항을 적어주세요. (최대 50자 이내)"
                        maxlength="50"
                        v-model="data.dlvDmndCn"
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- // D: MO 전용 -->
          </section>
          <section class="order-write-box">
            <div class="title-box c-title-level3">
              <strong>주문제품정보</strong>
            </div>
            <div class="c-order-control-box">
              <div class="left-box">
                <div class="c-checkbox type-small">
                  <input
                    type="checkbox"
                    id="all-chk1"
                    name="chkgroup1"
                    v-model="allChecked"
                  />
                  <label for="all-chk1">전체선택</label>
                </div>
                <button
                  type="button"
                  class="btn-selected-delete"
                  @click="deleteCheckedItems()"
                >
                  <i class="c-icon icon-check"></i>
                  <span>선택삭제</span>
                </button>
              </div>
            </div>
            <!-- D: PC 전용 -->
            <div class="scroll-x">
              <div class="scroll-x-inner">
                <div class="table-box only-pc" style="width: 1102px">
                  <div class="c-table">
                    <table>
                      <caption>
                        장바구니 리스트 테이블
                      </caption>
                      <colgroup>
                        <col style="width: 500px" />
                        <col style="width: 120px" />
                        <col style="width: 130px" />
                        <col style="width: 140px" />
                        <col style="width: 140px" />
                      </colgroup>
                      <thead>
                        <tr>
                          <th scope="col">제품</th>
                          <th scope="col">용량</th>
                          <th scope="col">재고</th>
                          <th scope="col">수량</th>
                          <th scope="col">금액</th>
                        </tr>
                      </thead>
                      <tbody>
                        <OrderTempRow
                          v-for="(item, index) in initData.list.itemList"
                          :key="item.matnr"
                          :index="index"
                          :item="item"
                          :werks="CODE_WERKS"
                          :checked="checkedItems[index]?.checked"
                          @checked="(checked) => handleCheck(index, checked)"
                          @item="(item) => updateItem(item)"
                        />
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- // D: PC 전용 -->
            <!-- D: MO 전용 -->
            <div class="c-products only-mo">
              <MoOrderTempRow
                v-for="(item, index) in initData.list.itemList"
                :key="item.matnr"
                :index="index"
                :item="item"
                :werks="CODE_WERKS"
                :checked="checkedItems[index]?.checked"
                @checked="(checked) => handleCheck(index, checked)"
                @item="(item) => updateItem(item)"
              />
            </div>
            <!-- // D: MO 전용 -->
          </section>
          <section class="order-write-box">
            <div class="title-box c-title-level3">
              <strong>배송 요청일</strong>
            </div>
            <ul class="c-dot-list">
              <li>
                별도 일정에 대한 부분은 담당영업사원에게 문의하시기 바랍니다.
              </li>
            </ul>
            <div class="c-form-field">
              <label
                v-show="data.selectedDlvCd !== '15'"
                class="c-input-calender"
              >
                <input
                  type="text"
                  title="배송 요청일"
                  placeholder="일자를 선택해 주세요"
                  required=""
                  readonly
                  data-datepicker
                  ref="datepickerRef"
                  v-model="data.selectedDate"
                />
              </label>
              <div v-show="data.selectedDlvCd === '15'">
                {{ data.selectedDate }}
              </div>
            </div>
            <div class="c-util-box">
              <div class="text-box">
                <span>주문 제품 {{ data.totalCount }}개</span>
                <span
                  >총 주문 금액
                  {{ Number(data.totalPrice).toLocaleString() }}원</span
                >
              </div>
              <button
                type="button"
                class="c-util-button type-large type-pink"
                @click="orderNow()"
              >
                <span class="bold">주문하기</span>
              </button>
            </div>
          </section>
          <!-- D: MO 전용 -->
          <div class="c-btn-area type-full is-fixed" data-bottom-fixed>
            <button
              type="button"
              class="c-button type-small type-primary"
              @click="orderNow()"
            >
              <span
                >주문하기 ({{ data.totalCount }}개
                {{ Number(data.totalPrice).toLocaleString() }}원)</span
              >
            </button>
          </div>
          <!-- // D: MO 전용 -->
        </div>
      </div>
    </div>

    <QuickMenu />
  </div>

  <AgencyDeliveryAddressEditPop
    v-if="initData.popup.isShowDlvdesPopup"
    v-bind="editPopProps"
    @close="() => (initData.popup.isShowDlvdesPopup = false)"
    @updated="loadAddresses"
  />

  <SetChkAlert ref="setChkAlert"></SetChkAlert>

  <!-- D: POPUP - Wrap밖으로 호출 필요 -->
  <OrderComplete v-if="initData.list.isModalVisible" />
</template>
<script setup>
import OrderComplete from "@/components/paintpro/order/orderComplete.vue";
import OrderTempRow from "@/components/paintpro/order/orderTempRow.vue";
import QuickMenu from "@/components/paintpro/quickMenu/quickMenu.vue";
import { api } from "@/plugins/api";
import { useAuthStore } from "@/store";
import { getLocalStorage } from "@/utils/cmUtil";
import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil";
import Utils from "@/js/utils";
import {
  computed,
  inject,
  onMounted,
  reactive,
  ref,
  watch,
  provide,
  readonly,
  nextTick,
} from "vue";
import { useRoute } from "vue-router";
import $ from "jquery";
import router from "@/router";
import SetChkAlert from "@/components/paintpro/prod/setChkAlert.vue";
import BreadCrumb from "@/components/paintpro/base/breadCrumb.vue";
import MoOrderTempRow from "@/components/paintpro/order/moOrderTempRow.vue";
import { popoverTrigger } from "@/js/_ui";
import * as store from "@/store";
import AgencyDeliveryAddressEditPop from "@/components/paintpro/agency/agencyDeliveryAddressEditPop.vue";
import utils from "@/js/utils";
const { isMobile } = cmUtil.useDeviceType();

const CODE_WERKS = ref([]);
provide("CODE_WERKS", readonly(CODE_WERKS));

const CODE_GOODS_FILE_SE_CD = ref([]);
provide("CODE_GOODS_FILE_SE_CD", readonly(CODE_GOODS_FILE_SE_CD));

const url = inject("url_prefix");
const authStore = useAuthStore();
const route = useRoute();
const setChkAlert = ref(null);
const datepickerRef = ref(null);
const thinnerList = ref(null); // 신나 리스트
const includeThinner = ref(false); // 신나 포함 여부
const checkedItems = ref([]); // 체크된 아이템 관리
const defaultAddress = ref(null);
const editPopProps = ref({
  address: null,
});

// 체크박스 전체선택
const allChecked = computed({
  get: () => checkedItems.value.every((item) => item.checked), // 전체선택 체크박스 값
  set: (value) =>
    (checkedItems.value = checkedItems.value.map((item) => ({
      ...item,
      checked: value,
    }))),
});
const noExistChecked = computed(() =>
  checkedItems.value.every((item) => item.checked === false)
);

const initData = reactive({
  page: {
    isLogin: false,
    deviceType: isMobile.value ? "M" : "P",
    userLoginInfo: {},
    basketCount: {},
    breadcrumbItems: [{ name: "주문서", path: "/paintpro/orderOrder" }],
    orderTempZempNo: "",
    orderTmpSn: route.query?.orderTmpSn,
    beOrderNo: route.query?.beOrderNo,
    empIndex: 0,
    reOrder: false,
    dlvrChng: route.query?.dlvrChng,
  },
  codes: {
    dlvCmmCdList: [], // 배송방법코드
    dlvRgnList: [], // 배송지역
    dlvPntList: [], // 배송지점
    userWerksList: [], // 플랜트(지점)
  },
  popup: {
    isModalVisible: false,
    isShowDlvdesPopup: false, // 배송지팝업
  },
  list: {
    itemListCount: 0,
    itemList: [],
    dlvAddressList: [],
    stockList: [],
  },
  eventBus: {
    salesPersonIndex: 0,
  },
});

const data = reactive({
  selectedDlvCd: null, // 배송방법코드
  selectedDlvCdNm: null, // 배송방법코드명
  selectedDlvRgn: null, // 배송지역
  selectedDlvPnt: null, // 배송지점
  selectedAddress_before: null,
  selectedAddress: {
    dlvdesSn: null /* 배송지일련번호 */,
    agencySn: null /* 대리점일련번호 */,
    dlvdesNm: null /* 배송지명 */,
    acptrNm: null /* 인수자명 */,
    acptrWrdTelno: null /* 인수자유선전화번호 */,
    acptrMblTelno: null /* 인수자휴대전화번호 */,
    acptrTelno1: null /* 인수자전화번호1 */,
    acptrTelno2: null /* 인수자전화번호2 */,
    zip: null /* 우편번호 */,
    ozip: null /* 구우편번호 */,
    roadNmBscAddr: null /* 도로명기본주소 */,
    roadNmDtlAddr: null /* 도로명상세주소 */,
    lotnoBscAddr: null /* 지번기본주소 */,
    lotnoDtlAddr: null /* 지번상세주소 */,
    bscDlvdesYn: null /* 기본배송지여부 */,
    useYn: null /* 사용여부 */,
    rgtr: null /* 등록자 */,
    regDt: null /* 등록일시 */,
    mdfr: null /* 수정자 */,
    mdfcnDt: null /* 수정일시 */,
  }, // 배송지
  acptrWrdTelno1: null,
  acptrWrdTelno2: null,
  acptrWrdTelno3: null,
  // 휴대폰 번호 입력창 병합 2025.11.25
  acptrMblTelno1: null,
  // acptrMblTelno2: null,
  // acptrMblTelno3: null,
  acptrMblTelnoRest: null,
  acptrMblTelnoSub1: null,
  // acptrMblTelnoSub2: null,
  // acptrMblTelnoSub3: null,
  acptrMblTelnoSubRest: null,
  acptrMblTelLengh: 1,
  selectedDate: null, // 배송요청일
  dlvDmndCn: null, // 배송요청내용
  dlvdesSn: null, // 배송지일련번호
  selectedBranch: null, // 담당영업사원
  totalPrice: computed(() =>
    checkedItems.value
      .filter((item) => item.checked)
      .reduce((sum, item) => {
        return sum + item.kbetr * item.goodsQty;
      }, 0)
  ), // 총 가격
  totalCount: computed(
    () => checkedItems.value.filter((item) => item.checked).length
  ),
  defaultAddr: null, // 기본배송지 여부
});

const userData = computed(() => {
  return {
    orderStatusCd: "0", // 주문상태코드 (주문대기:0)
    agencySn: initData.page.userLoginInfo.agencySn, // 대리점 일련번호
    kunnr: initData.page.userLoginInfo.kunnr, // 대리점 아이디
    zempNo: data.selectedBranch.kunn2, // 영업사원 아이디
    orderChnlCd: initData.page.deviceType, // PC, MOBILE
    dlvMthdCd: data.selectedDlvCd, // 배송방법코드
    dlvMthdCdNm: data.selectedDlvCdNm, // 배송방법코드명
    dlvdesSn: data.selectedAddress?.dlvdesSn || "", // 배송지 일련번호
    dlvDmndCn: data.dlvDmndCn, // 배송요청사항
    dlvDmndDay: data.selectedDate?.replace(/-/g, "") || "", // 배송요청일
    dlvRgnCd: data.selectedDlvRgn, // 대신화물 지역명
    dlvBranchCd: data.selectedDlvPnt, // 대신화물 지점명
    orderTmpSn: initData.page.orderTmpSn, // 임시주문번호
    dlvdesNm: data.selectedAddress?.dlvdesNm || "", // 배송지명
    acptrNm: data.selectedAddress?.acptrNm || "", // 인수자명
    acptrWrdTelno:
      data.selectedDlvCd == "20" || data.selectedDlvCd == "30"
        ? data.selectedAddress.acptrWrdTelno
        : data.acptrWrdTelno1 +
          "-" +
          data.acptrWrdTelno2 +
          "-" +
          data.acptrWrdTelno3, // 인수자 유선전화번호
    acptrMblTelno:
      utils.isNotBlank(data.acptrMblTelno1) == true
        ? // 휴대폰 번호 입력창 병합 2025.11.25
          buildMobileNumber(data.acptrMblTelno1, data.acptrMblTelnoRest)
        : // ? data.acptrMblTelno1 +
          //   "-" +
          //   data.acptrMblTelno2 +
          //   "-" +
          //   data.acptrMblTelno3
          "", // 인수자 휴대전화번호
    acptrTelno1:
      utils.isNotBlank(data.acptrMblTelnoSub1) == true
        ? // 휴대폰 번호 입력창 병합 2025.11.25
          buildMobileNumber(data.acptrMblTelnoSub1, data.acptrMblTelnoSubRest)
        : // ? data.acptrMblTelnoSub1 +
          //   "-" +
          //   data.acptrMblTelnoSub2 +
          //   "-" +
          //   data.acptrMblTelnoSub3
          "", // 추가 인수자 휴대전화번호
    zip:
      utils.isNotBlank(data.selectedAddress.zip) == true
        ? data.selectedAddress.zip
        : "", // 우편번호
    roadNmBscAddr:
      utils.isNotBlank(data.selectedAddress.roadNmBscAddr) == true
        ? data.selectedAddress.roadNmBscAddr
        : "", // 도로명기본주소
    roadNmDtlAddr:
      utils.isNotBlank(data.selectedAddress.roadNmDtlAddr) == true
        ? data.selectedAddress.roadNmDtlAddr
        : "", // 도로명상세주소
    defaultAddr:
      data.selectedDlvCd == "25" || data.selectedDlvCd == "18"
        ? "N"
        : data.defaultAddr || "", // 기본배송지 여부
    werksNm: initData.codes.userWerksList[0]?.cdNm, // 직출명
  };
});

const headerDataParam = computed(() => {
  return {
    CYB_ORDER: "", // 사이버샵 주문번호
    ERDAT_CYB: "", // 주문일
    ERZET_CYB: "", // 주문시간
    ERNAM_CYB: "10", // 생성자
    AUART: "ZOR1", // 문서유형
    VKORG: data.selectedBranch.vkorg, // 영업조직
    VTWEG: data.selectedBranch.vtweg, // 유통경로
    SPART: data.selectedBranch.spart, // 제품군
    VKBUR: data.selectedBranch.vkbur, // 영업소
    VKGRP: data.selectedBranch.vkgrp, // 영업그룹
    KUNNR_SP_CYB: initData.page.userLoginInfo.kunnr, // 판매처 (대리점 아이디)
    KUNNR_SH_CYB: initData.page.userLoginInfo.kunnr, // 납품처 (대리점 아이디)
    KUNNR_SE_CYB: data.selectedBranch.kunn2, // 영업사원 아이디
    NETWR_CYB: data.totalPrice, // 주문 총 금액
    WAERK: "KRW", // 전표통화
    VDATU: data.selectedDate?.replace(/-/g, "") || "", // 배송요청일
    VSBED: data.selectedDlvCd, // 배송코드
    MEMO_TEXT: data.dlvDmndCn, // 배송요청사항
    AGENCY_NAME: data.selectedDlvPnt, // 대신화물 지점명
    BNAME: data.selectedAddress?.acptrNm || "", // 인수자명
    TELF1:
      // 휴대폰 번호 입력창 병합 2025.11.25
      buildMobileNumber(data.acptrMblTelno1, data.acptrMblTelnoRest),
    // data.acptrMblTelno1 +
    // "-" +
    // data.acptrMblTelno2 +
    // "-" +
    // data.acptrMblTelno3, // 인수자 휴대전화번호
    POST_CODE1: data.selectedAddress?.zip || "", // 우편번호
    CITY1: data.selectedAddress?.roadNmBscAddr || "", // 도로명 기본주소
    STREET: data.selectedAddress?.roadNmDtlAddr || "", // 도로명 상세주소
    CITY2: "", // 도로명 구역
  };
});

const itemListParam = ref([]);
const updateItemListParam = async () => {
  // 체크된 제품번호
  const checkedGoodsSn = checkedItems.value
    .filter((item) => item.checked)
    .map((item) => item.goodsSn);

  itemListParam.value = initData.list.itemList
    .filter((item) => checkedGoodsSn.includes(item.goodsSn))
    .map((item) => ({
      CYB_ORDER: "", // 주문번호
      CYB_ORDER_ITEM_NO: "", // 주문품목번호
      MATNR: item.matnr, // 자재번호
      KWMENG_CYB: item.goodsQty, // 누적 오더 수량
      VRKME: item.kmein, // 판매단위
      NETPR_CYB: item.kbetr, // 품목단가
      NETWR_CYB: item.kbetr * item.goodsQty, // 품목금액
      WERKS: initData.page.userLoginInfo.vwerk, // 플랜트
      CAN_REQ_SYS: "", // 취소요청 시스템
      CAN_FLAG: "", // 취소플래그
      CAN_DATE: "", // 취소일자
      CAN_TIME: "", // 취소시간
      CAN_REASON: "", //취소사유
      GOODS_SN: item.goodsSn, // 제품 일련번호
      ZZMAKTX: item.zzmaktx, // 제품명
    }));

  // 배송방법 화물(20),직출(30)인 경우 배송지 관련 빈값
  if (data.selectedDlvCd == 20 || data.selectedDlvCd == 30) {
    data.selectedAddress.dlvdesSn = ""; // 배송지일련번호
    data.selectedAddress.dlvdesNm = ""; // 배송지명
    data.selectedAddress.zip = ""; // 우편번호
    data.selectedAddress.roadNmBscAddr = ""; // 도로명기본주소
    data.selectedAddress.roadNmDtlAddr = ""; // 도로명상세주소
  }

  // 기본배송지면 빈값으로 변경 (SAP 요구사항)
  if (data.selectedAddress.bscDlvdesYn == "Y") {
    data.defaultAddr = "Y";
  }
};

const wiredExcNumbers = [
  "02",
  "031",
  "032",
  "033",
  "041",
  "042",
  "043",
  "044",
  "051",
  "052",
  "053",
  "054",
  "055",
  "061",
  "062",
  "063",
  "064",
  "070",
]; // 유선 국번 리스트
const mobileExcNumbers = [
  "010",
  "011",
  "016",
  "017",
  "018",
  "019",
  "0502",
  "0503",
  "0504",
  "0503",
  "0508",
]; // 휴대폰 국번 리스트

// 주문
async function orderNow() {
  // 유효성 체크
  if (!(await checkValidation())) return;

  cmUtil.loading("", { duration: 60000 });

  await updateItemListParam(); // 주문시 필요값들 itemListParam

  if (data.selectedDlvCd === "18") {
    const resWerks = await api.get(`${url}/order/getPostWerk`, {
      params: { post: data.selectedAddress.zip },
    });

    if (resWerks.data.retCnt > 0) {
      for (var i = 0; i < itemListParam.value.length; i++) {
        itemListParam.value[i].WERKS = resWerks.data.werks;
      }
    } else {
      cmUtil.loadingHide();
      await cmUtil.alert(
        "<b>직송배송 불가 지역 안내</b><br><b>배송지 : </b>[" +
          resWerks.data.deliverySite +
          "] <br>물류상 사유로 인한 직송 배송 불가<br>해당 배송지 주문 필요 시<br>담당영업사원 문의 부탁드립니다."
      );
      return;
    }
  }

  for (var j = 0; j < itemListParam.value.length; j++) {
    const spWerkCnt = await api.get(`${url}/order/getSpecificWerks`, {
      params: { matnr: itemListParam.value[j].MATNR },
    });

    if (spWerkCnt.resultCode >= 1) {
      itemListParam.value[j].WERKS = "1004"; //특정 제품의 경우 안산공장
    }
  }

  const params = {
    api: {
      SD_HEADER: { item: headerDataParam.value },
      SD_ITEM: { item: itemListParam.value },
    },
    info: userData.value,
  };

  const res = await api.post(`${url}/order/doOrder`, params);
  cmUtil.loadingHide();
  if (res.resultCode === 200) {
    const confirmOrder = await cmUtil.alert("msg", { type: "orderComplete" });
    if (confirmOrder) {
      router.push({
        path: "/paintpro/orderList",
      });
    }
  } else {
    if (res.data) {
      initData.list.itemList.forEach((item) => {
        item.qtyLack = false;
        res.data.forEach((itemData) => {
          if (itemData.matnr === item.matnr) {
            item.qtyLack = true;
            item.availability = utils.currency(itemData.zztotalQty);
          }
        });
      });
    } else {
      initData.list.itemList.forEach((item) => {
        item.qtyLack = false;
      });
    }
  }
}

onMounted(() => {
  pageInit(); // 페이지 초기화 호출
});

async function pageInit() {
  const res = await cmApi.getPageInitData([
    { qId: "cmCode_code1", parm: { cdGrp: "WERKS" } },
    { qId: "cmCode_code2", parm: { cdGrp: "GOODS_FILE_SE_CD" } },
  ]);

  const { resultCode } = res;
  if (resultCode !== 200) {
    // alert(`errror : resultCode:${resultCode}, message:${message} `);
    return false;
  }
  CODE_WERKS.value = res.data.cmCode_code1;
  CODE_GOODS_FILE_SE_CD.value = res.data.cmCode_code2;

  await pageInitData();
  popoverTrigger(); // 팝오버
  getThinnerList(); // 신나 리스트
  await getDlvAddress(); // 배송지 리스트
  await getOrderTempList(); // 임시주문 리스트
  // await realtimeStockList(); // 실시간 재고
  // updateStock(); // 재고 업데이트 (실시간 재고 리스트 이후)
  jqueryDatepicker(); // 달력
  // 기본배송지
  defaultAddress.value = initData.list.dlvAddressList.find(
    (address) => address.bscDlvdesYn == "Y"
  );

  // 다시주문시 택배명이 변경된 경우는 배송지를 선택할 수 있도록 기본배송지를 비우고 시작 (dlvrChng:1 배송지변경됨)
  if (initData.page.dlvrChng != "1") {
    data.selectedAddress = Object.assign({}, defaultAddress.value);
    data.dlvdesSn = data.selectedAddress.dlvdesSn;
    if (data.selectedDlvCd == "18") {
      nullSettingDlv();
      initAddrData();
      // 다시주문시 과거주문이 택배고, 배송지명이 변경되지 않은 경우, 배송지목록에서 해당 배송지 선택
    }
  } else if (
    initData.page.reOrder &&
    (data.selectedDlvCd == "25" || data.selectedDlvCd == "18")
  ) {
    if (utils.isNotBlank(data.dlvdesSn)) {
      // 다시주문시 과거주문이 택배고, 배송지명이 변경되지 않은 경우, 배송지목록에서 해당 배송지 선택
      data.selectedAddress = initData.list.dlvAddressList.find(
        (item) => item.dlvdesSn == data.dlvdesSn
      );
    } else {
      nullSettingDlv();
    }
  }
}

const initAddrData = () => {
  nextTick(() => {
    const param = {
      params: {
        agencySn: userData.value.agencySn,
        orderNo: initData.page.beOrderNo,
      },
    };
    const res = api.get(`${url}/order/doBeOrder`, param);

    if (res.resultCode === 200) {
      //alert(`errror : resultCode:${resultCode}, message:${message}`);
      //data.dlvdesSn = res.data.dlvdesSn;
      //data.selectedAddress.acptrNm = res.data.acptrNm;
      //data.selectedAddress.roadNmBscAddr = res.data.roadNmBscAddr;
      //data.selectedAddress.zip = res.data.zip;
      //data.selectedAddress = res.data;
    }
  });
};

async function pageInitData() {
  // ◼◼◼ 초기데이타 조회
  const mparm = [];
  mparm.push({ qId: "cmCode_code1", parm: { cdGrp: "DLV_MTHD_CD" } });
  mparm.push({ qId: "cmCode_code2", parm: { cdGrp: "DLV_RGN_CD" } });
  mparm.push({
    qId: "cmCode_code3",
    parm: { cdGrp: "WERKS", dataRole: "vwerk" },
  });

  const res = await cmApi.getPageInitData(mparm);
  const { resultCode } = res;
  if (resultCode !== 200) {
    //alert(`errror : resultCode:${resultCode}, message:${message}`);
    return false;
  }

  const { cmCode_code1, cmCode_code2, cmCode_code3 } = res.data;
  initData.page.token = getLocalStorage("token");
  initData.page.isLogin = authStore?.user ? true : false;
  initData.page.userLoginInfo = authStore?.user;
  initData.codes.dlvCmmCdList = cmCode_code1;
  initData.codes.dlvRgnList = cmCode_code2;
  initData.codes.userWerksList = cmCode_code3;
}

// 임시주문 리스트
async function getOrderTempList() {
  const param = {
    params: {
      orderTmpSn: initData.page.orderTmpSn,
    },
  };
  const res = await api.get(`${url}/order/getOrderTempList`, param);
  if (res.resultCode === 200) {
    initData.list.itemList = res.data.orderTmpDtlList;
    initData.list.itemListCount = res.data.orderTmpDtlListCount;

    // 임시주문의 영업사원으로 변경
    const zempNo = res.data.orderTmp.zempNo;
    initData.page.empIndex = initData.page.userLoginInfo.empList.findIndex(
      (emp) => emp.kunn2 == zempNo
    );
    data.selectedBranch =
      initData.page.userLoginInfo.empList[initData.page.empIndex];
    saleEmpSelect();

    // 다시주문인 경우 과거주문의 배송방법으로 선택
    if (
      res.data.orderTmp.dlvMthdCd != null &&
      res.data.orderTmp.dlvMthdCd != ""
    ) {
      data.selectedDlvCd = res.data.orderTmp.dlvMthdCd;
      initData.page.reOrder = true;
    }

    // 체스리스트
    checkedItems.value = initData.list.itemList.map((item) => ({
      orderTmpSn: item.orderTmpSn,
      orderDtlTmpSn: item.orderDtlTmpSn,
      goodsSn: item.goodsSn,
      goodsQty: item.goodsQty,
      kbetr: item.kbetr,
      checked: true,
    }));
  } else {
    await cmUtil.alert(res.message);
    router.push("/paintpro/main");
  }
}

// 수량 업데이트
function updateItem(item) {
  const matchingItem = checkedItems.value.find(
    (target) => target.goodsSn == item.goodsSn
  );
  matchingItem.goodsQty = item.goodsQty;
}

// 배송지 리스트 API
async function getDlvAddress() {
  const res = await api.get(`${url}/agency/delivery/address/addresses`);
  const { resultCode } = res;
  if (resultCode !== 200) {
    //alert(`errror : resultCode:${resultCode}, message:${message} `);
    return;
  }

  initData.list.dlvAddressList = res.data;
}

// 배송지 추가/수정 후 로드
const loadAddresses = async () => {
  cmUtil.loading("", { duration: 60000 });
  const res = await api.get(`${url}/agency/delivery/address/addresses`);
  const { resultCode } = res;
  if (resultCode !== 200) {
    //alert(`errror : resultCode:${resultCode}, message:${message} `);
    return;
  }
  initData.list.dlvAddressList = res.data;
  data.selectedAddress = res.data.find(
    (item) => item.dlvdesSn == data.selectedAddress?.dlvdesSn
  );

  inputTelInit();
  cmUtil.loadingHide();
};

// 신나 리스트 API
async function getThinnerList() {
  const res = await api.get(`${url}/order/getThinnerList`);
  thinnerList.value = res.data;
}

watch(
  () => initData.list.itemList,
  () => {
    // 신나류 체크
    includeThinner.value = initData.list.itemList.some((item) =>
      thinnerList.value.some((thinner) => item.prodh3 == thinner.clsfCd)
    );
    // 제품 가격
    initData.list.itemList.forEach((item) => {
      item.itemPrice = item.kbetr * item.goodsQty;
    });
  }
);

// 신나류 포함시 배송방법초기화
watch(
  () => includeThinner.value,
  () => {
    if (includeThinner.value) {
      data.selectedDlvCd = null;
    }
  }
);

// 배송방법 택배 외 선택시 기본배송지로 변경
watch(
  () => data.selectedDlvCd,
  (newValue) => {
    if (newValue != "25" && newValue != "18") {
      data.selectedAddress = Object.assign({}, defaultAddress.value);
      data.dlvdesSn = data.selectedAddress.dlvdesSn;
    } else {
      nullSettingDlv();
      inputTelInit();
    }
  }
);

function nullSettingDlv() {
  data.dlvdesSn = "";
  data.selectedAddress = {
    dlvdesSn: "" /* 배송지일련번호 */,
    agencySn: "" /* 대리점일련번호 */,
    dlvdesNm: "" /* 배송지명 */,
    acptrNm: "" /* 인수자명 */,
    acptrWrdTelno: "" /* 인수자유선전화번호 */,
    acptrMblTelno: "" /* 인수자휴대전화번호 */,
    acptrTelno1: "" /* 인수자전화번호1 */,
    acptrTelno2: "" /* 인수자전화번호2 */,
    zip: "" /* 우편번호 */,
    ozip: "" /* 구우편번호 */,
    roadNmBscAddr: "" /* 도로명기본주소 */,
    roadNmDtlAddr: "" /* 도로명상세주소 */,
    lotnoBscAddr: "" /* 지번기본주소 */,
    lotnoDtlAddr: "" /* 지번상세주소 */,
    bscDlvdesYn: "" /* 기본배송지여부 */,
    useYn: "" /* 사용여부 */,
    rgtr: "" /* 등록자 */,
    regDt: "" /* 등록일시 */,
    mdfr: "" /* 수정자 */,
    mdfcnDt: "" /* 수정일시 */,
  };
}

// 배송지 선택 시
watch(
  () => data.dlvdesSn,
  (newValue) => {
    if (newValue) {
      loadAddresses();

      data.selectedAddress = initData.list.dlvAddressList.find(
        (item) => item.dlvdesSn == newValue
      );

      inputTelInit();
    } else {
      nullSettingDlv();
      inputTelInit();
    }
  }
);

function inputTelInit() {
  // 휴대폰 번호 입력창 병합 2025.11.25
  const mbl = data.selectedAddress.acptrMblTelno;

  if (utils.isNotBlank(mbl)) {
    const parts = mbl.split("-");
    const prefix = parts[0] || "";
    const mid = parts[1] || "";
    const last = parts[2] || "";

    data.acptrMblTelno1 = prefix;
    data.acptrMblTelnoRest = (mid + last).slice(0, 8); // "1234" + "5678" -> "12345678"
  } else {
    data.acptrMblTelno1 = "";
    data.acptrMblTelnoRest = "";
  }

  // if (Utils.isNotBlank(data.selectedAddress.acptrMblTelno)) {
  //   data.acptrMblTelno1 = data.selectedAddress.acptrMblTelno.split("-")[0];
  //   data.acptrMblTelno2 = data.selectedAddress.acptrMblTelno.split("-")[1];
  //   data.acptrMblTelno3 = data.selectedAddress.acptrMblTelno.split("-")[2];
  // } else {
  //   data.acptrMblTelno1 = "";
  //   data.acptrMblTelno2 = "";
  //   data.acptrMblTelno3 = "";
  // }

  if (Utils.isNotBlank(data.selectedAddress.acptrWrdTelno)) {
    data.acptrWrdTelno1 = data.selectedAddress.acptrWrdTelno.split("-")[0];
    data.acptrWrdTelno2 = data.selectedAddress.acptrWrdTelno.split("-")[1];
    data.acptrWrdTelno3 = data.selectedAddress.acptrWrdTelno.split("-")[2];
  } else {
    data.acptrWrdTelno1 = "";
    data.acptrWrdTelno2 = "";
    data.acptrWrdTelno3 = "";
  }

  // 휴대폰 번호 입력창 병합 2025.11.25
  const mblSub = data.selectedAddress.acptrTelno1;

  if (utils.isNotBlank(mblSub)) {
    const parts = mblSub.split("-");
    const prefix = parts[0] || "";
    const mid = parts[1] || "";
    const last = parts[2] || "";

    data.acptrMblTelnoSub1 = prefix;
    data.acptrMblTelnoSubRest = (mid + last).slice(0, 8); // "1234" + "5678" -> "12345678"
  } else {
    data.acptrMblTelnoSub1 = "";
    data.acptrMblTelnoSubRest = "";
  }

  // if (Utils.isNotBlank(data.selectedAddress.acptrTelno1)) {
  //   data.acptrMblTelnoSub1 = data.selectedAddress.acptrTelno1.split("-")[0];
  //   data.acptrMblTelnoSub2 = data.selectedAddress.acptrTelno1.split("-")[1];
  //   data.acptrMblTelnoSub3 = data.selectedAddress.acptrTelno1.split("-")[2];
  //   data.acptrMblTelLengh = 2;
  // } else {
  //   data.acptrMblTelLengh = 1;
  //   data.acptrMblTelnoSub1 = "";
  //   data.acptrMblTelnoSub2 = "";
  //   data.acptrMblTelnoSub3 = "";
  // }
}

// 배송지역 변경 시
watch(
  () => data.selectedDlvRgn,
  (newValue) => {
    data.selectedDlvRgn = newValue;
    getDlvPntList();
  }
);

// GNB 영업사원 리스트 연동
watch(
  () => store.useEventBusStore()?.salesPersonIndex,
  (newValue) => {
    initData.eventBus.salesPersonIndex = newValue;
    if (
      newValue >= 0 &&
      initData.page.userLoginInfo?.empList?.length > newValue
    ) {
      initData.page.empIndex = newValue;
      data.selectedBranch =
        initData.page.userLoginInfo.empList[initData.page.empIndex];
    }
  }
);

// 영업사원 선택
function saleEmpSelect() {
  initData.page.empIndex = initData.page.userLoginInfo.empList.findIndex(
    (item) => item.kunn2 == data.selectedBranch.kunn2
  );
  store.useEventBusStore().setSalesPersonIndex(initData.page.empIndex);
  cmApi.updateUserPersonInfo({
    type: "saleEmpSelect",
    chcZempNo: data.selectedBranch.kunn2,
  });
}

// 배송지점 리스트 API
async function getDlvPntList() {
  const res = await api.get(`${url}/order/getDlvPntList`, {
    params: { dlvRgn: data.selectedDlvRgn },
  });
  initData.codes.dlvPntList = res.data;
}

// 배송지 숨기기
function hideDlvdes(item) {
  if (data.selectedDlvCd != 25 && data.selectedDlvCd != 18) {
    if (item.bscDlvdesYn == "Y") return true;
  } else {
    return true;
  }
}

// 배송지 추가
const showEditPopForAdd = () => {
  editPopProps.value.address = null;
  initData.popup.isShowDlvdesPopup = true;
};

const addressDtlInput = () => {
  //주소에 특정 특수문자 제거
  data.selectedAddress.roadNmDtlAddr =
    data.selectedAddress.roadNmDtlAddr.replace(/[\t"|]/g, "");
};

// 배송지 수정
const showEditPopForEdit = () => {
  editPopProps.value.address = data.selectedAddress;
  initData.popup.isShowDlvdesPopup = true;
};

// 선택삭제
async function deleteCheckedItems() {
  if (noExistChecked.value) {
    await cmUtil.alert("제품을 선택해주세요.");
    return;
  }
  if (allChecked.value == true) {
    await cmUtil.alert(
      "주문제품을 모두 삭제 할 수 없습니다.<br>주문 제품 1개는 있어야 주문이 가능합니다."
    );
    return;
  }

  const deleteItemList = checkedItems.value.filter(
    (item) => item.checked === true
  );
  try {
    const res = await api.post(
      `${url}/order/deleteOrderTempDetail`,
      deleteItemList
    );
    if (res.resultCode === 200) {
      await cmUtil.alert("삭제되었습니다.");
      await getOrderTempList();
    }
  } catch (e) {
    console.log("error=" + e.message);
  }
}

// ROW 체크박스
function handleCheck(index, checked) {
  checkedItems.value[index].checked = checked;
}

async function checkValidation() {
  if (noExistChecked.value) {
    await cmUtil.alert("주문할 제품을 선택하세요.");
    return false;
  }
  if (data.selectedDlvCd === null) {
    await cmUtil.alert("배송방법을 선택하세요.");
    return false;
  }
  if (data.selectedAddress === null) {
    await cmUtil.alert("배송지를 선택하세요.");
    return false;
  }
  if (data.selectedDlvCd === "20") {
    if (data.selectedDlvRgn === null) {
      await cmUtil.alert("대신화물 지역을 선택하세요.");
      return false;
    }
    if (data.selectedDlvPnt === null) {
      await cmUtil.alert("대신화물 지점을 선택하세요.");
      return false;
    }
  }
  if (data.selectedDate === null) {
    await cmUtil.alert("배송요청일을 선택하세요.");
    return false;
  }
  if (Utils.isBlank(data.selectedAddress.acptrNm)) {
    await cmUtil.alert("받는 분을 입력하세요.");
    return false;
  }
  if (data.selectedAddress.acptrNm.length > 10) {
    await cmUtil.alert("받는 분의 최대 길이는 10입니다.");
    return false;
  }
  if (Utils.isBlank(data.acptrMblTelno1)) {
    await cmUtil.alert("휴대폰 번호의 국번을 선택해주세요.");
    return false;
  }
  // 휴대폰 번호 입력창 병합 2025.11.25
  // if (Utils.isBlank(data.acptrMblTelno2)) {
  //   await cmUtil.alert("휴대폰 번호의 가운데 번호를 입력하세요.");
  //   return false;
  // }
  // if (Utils.isBlank(data.acptrMblTelno3)) {
  //   await cmUtil.alert("휴대폰 번호의 마지막 번호를 입력하세요.");
  //   return false;
  // }
  // if (isNaN(data.acptrMblTelno2)) {
  //   await cmUtil.alert("휴대폰 번호의가운데 번호를 숫자로만 입력하세요");
  //   return false;
  // } else if (isNaN(data.acptrMblTelno3)) {
  //   await cmUtil.alert("휴대폰 번호의마지막 번호를 숫자로만 입력하세요");
  //   return false;
  // }
  if (utils.isBlank(data.acptrMblTelnoRest)) {
    await cmUtil.alert("휴대폰 번호 뒷자리를 입력하세요.");
    return false;
  }
  const digits = data.acptrMblTelnoRest.replace(/\D/g, "");
  if (digits.length !== 7 && digits.length !== 8) {
    await cmUtil.alert("휴대폰 번호 뒷자리는 8자리로 입력하세요.");
    return false;
  }

  if (
    Utils.isBlank(data.selectedAddress.zip) ||
    Utils.isBlank(data.selectedAddress.roadNmBscAddr)
  ) {
    await cmUtil.alert("주소를 입력하세요.");
    return false;
  }

  return true;
}

// jquery 달력
function jqueryDatepicker() {
  if (datepickerRef.value == null) return;
  $(datepickerRef.value).datepicker({
    showOn: "both",
    buttonText: "달력",
    changeYear: true,
    changeMonth: true,
    showOtherMonths: true,
    selectOtherMonths: true,
    nextText: "다음 달",
    prevText: "이전 달",
    dateFormat: "yy-mm-dd",
    minDate: 0,
    monthNamesShort: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
    ],
    beforeShow: function (input, inst) {
      inst.dpDiv.addClass("order-calendar");
    },
    // 날짜 선택 후 콜백
    onSelect: function (dateText) {
      // 날짜 선택 후 추가 작업 가능
      data.selectedDate = dateText;
    },
  });
}

// 우편번호 검색 API를 여는 함수
const openKakaoPostcode = async () => {
  if (
    typeof window.daum === "undefined" ||
    typeof window.daum.Postcode === "undefined"
  ) {
    await cmUtil.alert("카카오 우편번호 API가 로드되지 않았습니다.");
    return;
  }

  new window.daum.Postcode({
    oncomplete: function (result) {
      data.selectedAddress.zip = result.zonecode;
      data.selectedAddress.ozip = "";
      data.selectedAddress.roadNmBscAddr =
        result.userSelectedType === "R" // R: 도로명, J: 지번
          ? result.roadAddress
          : result.jibunAddress;
      data.selectedAddress.lotnoBscAddr = result.jibunAddress;

      data.selectedAddress.roadNmDtlAddr = "";
      data.selectedAddress.lotnoDtlAddr = "";
    },
  }).open();
};

function selectedDlvCdChange() {
  if (data.selectedDlvCd === "15") {
    const today = new Date();
    let resultDate = new Date(today);
    resultDate.setDate(today.getDate() + 1);
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };
    let resultDateStr = resultDate.toLocaleDateString("en-CA", options);
    data.selectedDate = resultDateStr;
  } else {
    data.selectedDate = null;
  }
}

const extTelnosLength = computed(() => {
  return data.acptrMblTelLengh;
});

function addExtMblTelNo() {
  data.acptrMblTelLengh = 2;
}

function removeExtMblTelNo() {
  data.acptrMblTelLengh = 1;
  data.selectedAddress.acptrTelno1 = null;
  // 휴대폰 번호 입력창 병합 2025.11.25
  data.acptrMblTelnoSub1 = "";
  // data.acptrMblTelnoSub2 = "";
  // data.acptrMblTelnoSub3 = "";
  data.acptrMblTelnoSubRest = "";
}

// 휴대폰 번호 입력창 병합 2025.11.25
function onMobileRestInput1(e) {
  // 숫자만 허용 + 최대 8자리
  const onlyDigits = e.target.value.replace(/\D/g, "");
  data.acptrMblTelnoRest = onlyDigits.slice(0, 8);
}

function onMobileRestInput2(e) {
  // 숫자만 허용 + 최대 8자리
  const onlyDigits = e.target.value.replace(/\D/g, "");
  data.acptrMblTelnoSubRest = onlyDigits.slice(0, 8);
}

function buildMobileNumber(prefix, rest) {
  if (utils.isBlank(prefix) || utils.isBlank(rest)) return "";

  const digits = rest.replace(/\D/g, "");

  if (digits.length === 8) {
    // 4-4로: 010-1234-5678
    return `${prefix}-${digits.slice(0, 4)}-${digits.slice(4)}`;
  }

  if (digits.length === 7) {
    // 3-4로: 011-234-5678 같은 케이스
    return `${prefix}-${digits.slice(0, 3)}-${digits.slice(3)}`;
  }

  return `${prefix}-${digits}`;
}
</script>
